module.exports = __webpack_public_path__ + "static/media/reg2.c7d9a31f.jpg";